(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.bvApi = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
/*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code, and use
	// it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	var InvalidCharacterError = function(message) {
		this.message = message;
	};
	InvalidCharacterError.prototype = new Error;
	InvalidCharacterError.prototype.name = 'InvalidCharacterError';

	var error = function(message) {
		// Note: the error messages used throughout this file match those used by
		// the native `atob`/`btoa` implementation in Chromium.
		throw new InvalidCharacterError(message);
	};

	var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	// http://whatwg.org/html/common-microsyntaxes.html#space-character
	var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

	// `decode` is designed to be fully compatible with `atob` as described in the
	// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
	// The optimized base64-decoding algorithm used is based on @atk’s excellent
	// implementation. https://gist.github.com/atk/1020396
	var decode = function(input) {
		input = String(input)
			.replace(REGEX_SPACE_CHARACTERS, '');
		var length = input.length;
		if (length % 4 == 0) {
			input = input.replace(/==?$/, '');
			length = input.length;
		}
		if (
			length % 4 == 1 ||
			// http://whatwg.org/C#alphanumeric-ascii-characters
			/[^+a-zA-Z0-9/]/.test(input)
		) {
			error(
				'Invalid character: the string to be decoded is not correctly encoded.'
			);
		}
		var bitCounter = 0;
		var bitStorage;
		var buffer;
		var output = '';
		var position = -1;
		while (++position < length) {
			buffer = TABLE.indexOf(input.charAt(position));
			bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
			// Unless this is the first of a group of 4 characters…
			if (bitCounter++ % 4) {
				// …convert the first 8 bits to a single ASCII character.
				output += String.fromCharCode(
					0xFF & bitStorage >> (-2 * bitCounter & 6)
				);
			}
		}
		return output;
	};

	// `encode` is designed to be fully compatible with `btoa` as described in the
	// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
	var encode = function(input) {
		input = String(input);
		if (/[^\0-\xFF]/.test(input)) {
			// Note: no need to special-case astral symbols here, as surrogates are
			// matched, and the input is supposed to only contain ASCII anyway.
			error(
				'The string to be encoded contains characters outside of the ' +
				'Latin1 range.'
			);
		}
		var padding = input.length % 3;
		var output = '';
		var position = -1;
		var a;
		var b;
		var c;
		var buffer;
		// Make sure any padding is handled outside of the loop.
		var length = input.length - padding;

		while (++position < length) {
			// Read three bytes, i.e. 24 bits.
			a = input.charCodeAt(position) << 16;
			b = input.charCodeAt(++position) << 8;
			c = input.charCodeAt(++position);
			buffer = a + b + c;
			// Turn the 24 bits into four chunks of 6 bits each, and append the
			// matching character for each of them to the output.
			output += (
				TABLE.charAt(buffer >> 18 & 0x3F) +
				TABLE.charAt(buffer >> 12 & 0x3F) +
				TABLE.charAt(buffer >> 6 & 0x3F) +
				TABLE.charAt(buffer & 0x3F)
			);
		}

		if (padding == 2) {
			a = input.charCodeAt(position) << 8;
			b = input.charCodeAt(++position);
			buffer = a + b;
			output += (
				TABLE.charAt(buffer >> 10) +
				TABLE.charAt((buffer >> 4) & 0x3F) +
				TABLE.charAt((buffer << 2) & 0x3F) +
				'='
			);
		} else if (padding == 1) {
			buffer = input.charCodeAt(position);
			output += (
				TABLE.charAt(buffer >> 2) +
				TABLE.charAt((buffer << 4) & 0x3F) +
				'=='
			);
		}

		return output;
	};

	var base64 = {
		'encode': encode,
		'decode': decode,
		'version': '1.0.0'
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define(function() {
			return base64;
		});
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = base64;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in base64) {
				base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.base64 = base64;
	}

}(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],2:[function(require,module,exports){
exports.defaults = {};

exports.set = function(name, value, options) {
  // Retrieve options and defaults
  var opts = options || {};
  var defaults = exports.defaults;

  // Apply default value for unspecified options
  var expires  = opts.expires  || defaults.expires;
  var domain   = opts.domain   || defaults.domain;
  var path     = opts.path     !== undefined ? opts.path     : (defaults.path !== undefined ? defaults.path : '/');
  var secure   = opts.secure   !== undefined ? opts.secure   : defaults.secure;
  var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;
  var samesite = opts.samesite !== undefined ? opts.samesite : defaults.samesite;

  // Determine cookie expiration date
  // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
  var expDate = expires ? new Date(
      // in case expires is an integer, it should specify the number of days till the cookie expires
      typeof expires === 'number' ? new Date().getTime() + (expires * 864e5) :
      // else expires should be either a Date object or in a format recognized by Date.parse()
      expires
  ) : 0;

  // Set cookie
  document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent)                // Encode cookie name
  .replace('(', '%28')
  .replace(')', '%29') +
  '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) +                  // Encode cookie value (RFC6265)
  (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
  (domain   ? ';domain=' + domain     : '') +                                      // Add domain
  (path     ? ';path='   + path       : '') +                                      // Add path
  (secure   ? ';secure'               : '') +                                      // Add secure option
  (httponly ? ';httponly'             : '') +                                      // Add httponly option
  (samesite ? ';samesite=' + samesite : '');                                       // Add samesite option
};

exports.get = function(name) {
  var cookies = document.cookie.split(';');
  
  // Iterate all cookies
  while(cookies.length) {
    var cookie = cookies.pop();

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));

    // Return cookie value if the name matches
    if (cookie_name === name) {
      return decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
  }

  // Return `null` as the cookie was not found
  return null;
};

exports.erase = function(name, options) {
  exports.set(name, '', {
    expires:  -1,
    domain:   options && options.domain,
    path:     options && options.path,
    secure:   0,
    httponly: 0}
  );
};

exports.all = function() {
  var all = {};
  var cookies = document.cookie.split(';');

  // Iterate all cookies
  while(cookies.length) {
    var cookie = cookies.pop();

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

    // add the cookie name and value to the `all` object
    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
    all[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
  }

  return all;
};

},{}],3:[function(require,module,exports){
var engine = require('../src/store-engine')

var storages = require('../storages/all')
var plugins = [require('../plugins/json2')]

module.exports = engine.createStore(storages, plugins)

},{"../plugins/json2":4,"../src/store-engine":6,"../storages/all":8}],4:[function(require,module,exports){
module.exports = json2Plugin

function json2Plugin() {
	require('./lib/json2')
	return {}
}

},{"./lib/json2":5}],5:[function(require,module,exports){
/* eslint-disable */

//  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html

//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.

//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.

//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.

//          For example, this would serialize Dates as ISO strings.

//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };

//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.

//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.

//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.

//          JSON.stringify(undefined) returns undefined.

//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.

//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.

//          Example:

//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'

//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'

//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.

//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.

//          Example:

//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.

//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });

//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });

//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.

/*jslint
    eval, for, this
*/

/*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if (typeof JSON !== "object") {
    JSON = {};
}

(function () {
    "use strict";

    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10
            ? "0" + n
            : n;
    }

    function this_value() {
        return this.valueOf();
    }

    if (typeof Date.prototype.toJSON !== "function") {

        Date.prototype.toJSON = function () {

            return isFinite(this.valueOf())
                ? this.getUTCFullYear() + "-" +
                        f(this.getUTCMonth() + 1) + "-" +
                        f(this.getUTCDate()) + "T" +
                        f(this.getUTCHours()) + ":" +
                        f(this.getUTCMinutes()) + ":" +
                        f(this.getUTCSeconds()) + "Z"
                : null;
        };

        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }

    var gap;
    var indent;
    var meta;
    var rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string)
            ? "\"" + string.replace(rx_escapable, function (a) {
                var c = meta[a];
                return typeof c === "string"
                    ? c
                    : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + "\""
            : "\"" + string + "\"";
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i;          // The loop counter.
        var k;          // The member key.
        var v;          // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === "object" &&
                typeof value.toJSON === "function") {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === "function") {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case "string":
            return quote(value);

        case "number":

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value)
                ? String(value)
                : "null";

        case "boolean":
        case "null":

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce "null". The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is "object", we might be dealing with an object or an array or
// null.

        case "object":

// Due to a specification blunder in ECMAScript, typeof null is "object",
// so watch out for that case.

            if (!value) {
                return "null";
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === "[object Array]") {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || "null";
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0
                    ? "[]"
                    : gap
                        ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]"
                        : "[" + partial.join(",") + "]";
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === "object") {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0
                ? "{}"
                : gap
                    ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}"
                    : "{" + partial.join(",") + "}";
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== "function") {
        meta = {    // table of character substitutions
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            "\"": "\\\"",
            "\\": "\\\\"
        };
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = "";
            indent = "";

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === "number") {
                for (i = 0; i < space; i += 1) {
                    indent += " ";
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === "string") {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== "function" &&
                    (typeof replacer !== "object" ||
                    typeof replacer.length !== "number")) {
                throw new Error("JSON.stringify");
            }

// Make a fake root object containing our value under the key of "".
// Return the result of stringifying the value.

            return str("", {"": value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== "function") {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k;
                var v;
                var value = holder[key];
                if (value && typeof value === "object") {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            rx_dangerous.lastIndex = 0;
            if (rx_dangerous.test(text)) {
                text = text.replace(rx_dangerous, function (a) {
                    return "\\u" +
                            ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with "()" and "new"
// because they can cause invocation, and "=" because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
// replace all simple value tokens with "]" characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or "]" or
// "," or ":" or "{" or "}". If that is so, then the text is safe for eval.

            if (
                rx_one.test(
                    text
                        .replace(rx_two, "@")
                        .replace(rx_three, "]")
                        .replace(rx_four, "")
                )
            ) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The "{" operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval("(" + text + ")");

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return (typeof reviver === "function")
                    ? walk({"": j}, "")
                    : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError("JSON.parse");
        };
    }
}());
},{}],6:[function(require,module,exports){
var util = require('./util')
var slice = util.slice
var pluck = util.pluck
var each = util.each
var bind = util.bind
var create = util.create
var isList = util.isList
var isFunction = util.isFunction
var isObject = util.isObject

module.exports = {
	createStore: createStore
}

var storeAPI = {
	version: '2.0.12',
	enabled: false,
	
	// get returns the value of the given key. If that value
	// is undefined, it returns optionalDefaultValue instead.
	get: function(key, optionalDefaultValue) {
		var data = this.storage.read(this._namespacePrefix + key)
		return this._deserialize(data, optionalDefaultValue)
	},

	// set will store the given value at key and returns value.
	// Calling set with value === undefined is equivalent to calling remove.
	set: function(key, value) {
		if (value === undefined) {
			return this.remove(key)
		}
		this.storage.write(this._namespacePrefix + key, this._serialize(value))
		return value
	},

	// remove deletes the key and value stored at the given key.
	remove: function(key) {
		this.storage.remove(this._namespacePrefix + key)
	},

	// each will call the given callback once for each key-value pair
	// in this store.
	each: function(callback) {
		var self = this
		this.storage.each(function(val, namespacedKey) {
			callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
		})
	},

	// clearAll will remove all the stored key-value pairs in this store.
	clearAll: function() {
		this.storage.clearAll()
	},

	// additional functionality that can't live in plugins
	// ---------------------------------------------------

	// hasNamespace returns true if this store instance has the given namespace.
	hasNamespace: function(namespace) {
		return (this._namespacePrefix == '__storejs_'+namespace+'_')
	},

	// createStore creates a store.js instance with the first
	// functioning storage in the list of storage candidates,
	// and applies the the given mixins to the instance.
	createStore: function() {
		return createStore.apply(this, arguments)
	},
	
	addPlugin: function(plugin) {
		this._addPlugin(plugin)
	},
	
	namespace: function(namespace) {
		return createStore(this.storage, this.plugins, namespace)
	}
}

function _warn() {
	var _console = (typeof console == 'undefined' ? null : console)
	if (!_console) { return }
	var fn = (_console.warn ? _console.warn : _console.log)
	fn.apply(_console, arguments)
}

function createStore(storages, plugins, namespace) {
	if (!namespace) {
		namespace = ''
	}
	if (storages && !isList(storages)) {
		storages = [storages]
	}
	if (plugins && !isList(plugins)) {
		plugins = [plugins]
	}

	var namespacePrefix = (namespace ? '__storejs_'+namespace+'_' : '')
	var namespaceRegexp = (namespace ? new RegExp('^'+namespacePrefix) : null)
	var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
	if (!legalNamespaces.test(namespace)) {
		throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes')
	}
	
	var _privateStoreProps = {
		_namespacePrefix: namespacePrefix,
		_namespaceRegexp: namespaceRegexp,

		_testStorage: function(storage) {
			try {
				var testStr = '__storejs__test__'
				storage.write(testStr, testStr)
				var ok = (storage.read(testStr) === testStr)
				storage.remove(testStr)
				return ok
			} catch(e) {
				return false
			}
		},

		_assignPluginFnProp: function(pluginFnProp, propName) {
			var oldFn = this[propName]
			this[propName] = function pluginFn() {
				var args = slice(arguments, 0)
				var self = this

				// super_fn calls the old function which was overwritten by
				// this mixin.
				function super_fn() {
					if (!oldFn) { return }
					each(arguments, function(arg, i) {
						args[i] = arg
					})
					return oldFn.apply(self, args)
				}

				// Give mixing function access to super_fn by prefixing all mixin function
				// arguments with super_fn.
				var newFnArgs = [super_fn].concat(args)

				return pluginFnProp.apply(self, newFnArgs)
			}
		},

		_serialize: function(obj) {
			return JSON.stringify(obj)
		},

		_deserialize: function(strVal, defaultVal) {
			if (!strVal) { return defaultVal }
			// It is possible that a raw string value has been previously stored
			// in a storage without using store.js, meaning it will be a raw
			// string value instead of a JSON serialized string. By defaulting
			// to the raw string value in case of a JSON parse error, we allow
			// for past stored values to be forwards-compatible with store.js
			var val = ''
			try { val = JSON.parse(strVal) }
			catch(e) { val = strVal }

			return (val !== undefined ? val : defaultVal)
		},
		
		_addStorage: function(storage) {
			if (this.enabled) { return }
			if (this._testStorage(storage)) {
				this.storage = storage
				this.enabled = true
			}
		},

		_addPlugin: function(plugin) {
			var self = this

			// If the plugin is an array, then add all plugins in the array.
			// This allows for a plugin to depend on other plugins.
			if (isList(plugin)) {
				each(plugin, function(plugin) {
					self._addPlugin(plugin)
				})
				return
			}

			// Keep track of all plugins we've seen so far, so that we
			// don't add any of them twice.
			var seenPlugin = pluck(this.plugins, function(seenPlugin) {
				return (plugin === seenPlugin)
			})
			if (seenPlugin) {
				return
			}
			this.plugins.push(plugin)

			// Check that the plugin is properly formed
			if (!isFunction(plugin)) {
				throw new Error('Plugins must be function values that return objects')
			}

			var pluginProperties = plugin.call(this)
			if (!isObject(pluginProperties)) {
				throw new Error('Plugins must return an object of function properties')
			}

			// Add the plugin function properties to this store instance.
			each(pluginProperties, function(pluginFnProp, propName) {
				if (!isFunction(pluginFnProp)) {
					throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
				}
				self._assignPluginFnProp(pluginFnProp, propName)
			})
		},
		
		// Put deprecated properties in the private API, so as to not expose it to accidential
		// discovery through inspection of the store object.
		
		// Deprecated: addStorage
		addStorage: function(storage) {
			_warn('store.addStorage(storage) is deprecated. Use createStore([storages])')
			this._addStorage(storage)
		}
	}

	var store = create(_privateStoreProps, storeAPI, {
		plugins: []
	})
	store.raw = {}
	each(store, function(prop, propName) {
		if (isFunction(prop)) {
			store.raw[propName] = bind(store, prop)			
		}
	})
	each(storages, function(storage) {
		store._addStorage(storage)
	})
	each(plugins, function(plugin) {
		store._addPlugin(plugin)
	})
	return store
}

},{"./util":7}],7:[function(require,module,exports){
(function (global){(function (){
var assign = make_assign()
var create = make_create()
var trim = make_trim()
var Global = (typeof window !== 'undefined' ? window : global)

module.exports = {
	assign: assign,
	create: create,
	trim: trim,
	bind: bind,
	slice: slice,
	each: each,
	map: map,
	pluck: pluck,
	isList: isList,
	isFunction: isFunction,
	isObject: isObject,
	Global: Global
}

function make_assign() {
	if (Object.assign) {
		return Object.assign
	} else {
		return function shimAssign(obj, props1, props2, etc) {
			for (var i = 1; i < arguments.length; i++) {
				each(Object(arguments[i]), function(val, key) {
					obj[key] = val
				})
			}			
			return obj
		}
	}
}

function make_create() {
	if (Object.create) {
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
		}
	} else {
		function F() {} // eslint-disable-line no-inner-declarations
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			F.prototype = obj
			return assign.apply(this, [new F()].concat(assignArgsList))
		}
	}
}

function make_trim() {
	if (String.prototype.trim) {
		return function trim(str) {
			return String.prototype.trim.call(str)
		}
	} else {
		return function trim(str) {
			return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
		}
	}
}

function bind(obj, fn) {
	return function() {
		return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
	}
}

function slice(arr, index) {
	return Array.prototype.slice.call(arr, index || 0)
}

function each(obj, fn) {
	pluck(obj, function(val, key) {
		fn(val, key)
		return false
	})
}

function map(obj, fn) {
	var res = (isList(obj) ? [] : {})
	pluck(obj, function(v, k) {
		res[k] = fn(v, k)
		return false
	})
	return res
}

function pluck(obj, fn) {
	if (isList(obj)) {
		for (var i=0; i<obj.length; i++) {
			if (fn(obj[i], i)) {
				return obj[i]
			}
		}
	} else {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (fn(obj[key], key)) {
					return obj[key]
				}
			}
		}
	}
}

function isList(val) {
	return (val != null && typeof val != 'function' && typeof val.length == 'number')
}

function isFunction(val) {
	return val && {}.toString.call(val) === '[object Function]'
}

function isObject(val) {
	return val && {}.toString.call(val) === '[object Object]'
}

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],8:[function(require,module,exports){
module.exports = [
	// Listed in order of usage preference
	require('./localStorage'),
	require('./oldFF-globalStorage'),
	require('./oldIE-userDataStorage'),
	require('./cookieStorage'),
	require('./sessionStorage'),
	require('./memoryStorage')
]

},{"./cookieStorage":9,"./localStorage":10,"./memoryStorage":11,"./oldFF-globalStorage":12,"./oldIE-userDataStorage":13,"./sessionStorage":14}],9:[function(require,module,exports){
// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var util = require('../src/util')
var Global = util.Global
var trim = util.trim

module.exports = {
	name: 'cookieStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var doc = Global.document

function read(key) {
	if (!key || !_has(key)) { return null }
	var regexpStr = "(?:^|.*;\\s*)" +
		escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
		"\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"
	return unescape(doc.cookie.replace(new RegExp(regexpStr), "$1"))
}

function each(callback) {
	var cookies = doc.cookie.split(/; ?/g)
	for (var i = cookies.length - 1; i >= 0; i--) {
		if (!trim(cookies[i])) {
			continue
		}
		var kvp = cookies[i].split('=')
		var key = unescape(kvp[0])
		var val = unescape(kvp[1])
		callback(val, key)
	}
}

function write(key, data) {
	if(!key) { return }
	doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/"
}

function remove(key) {
	if (!key || !_has(key)) {
		return
	}
	doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
}

function clearAll() {
	each(function(_, key) {
		remove(key)
	})
}

function _has(key) {
	return (new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(doc.cookie)
}

},{"../src/util":7}],10:[function(require,module,exports){
var util = require('../src/util')
var Global = util.Global

module.exports = {
	name: 'localStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

function localStorage() {
	return Global.localStorage
}

function read(key) {
	return localStorage().getItem(key)
}

function write(key, data) {
	return localStorage().setItem(key, data)
}

function each(fn) {
	for (var i = localStorage().length - 1; i >= 0; i--) {
		var key = localStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return localStorage().removeItem(key)
}

function clearAll() {
	return localStorage().clear()
}

},{"../src/util":7}],11:[function(require,module,exports){
// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.

module.exports = {
	name: 'memoryStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var memoryStorage = {}

function read(key) {
	return memoryStorage[key]
}

function write(key, data) {
	memoryStorage[key] = data
}

function each(callback) {
	for (var key in memoryStorage) {
		if (memoryStorage.hasOwnProperty(key)) {
			callback(memoryStorage[key], key)
		}
	}
}

function remove(key) {
	delete memoryStorage[key]
}

function clearAll(key) {
	memoryStorage = {}
}

},{}],12:[function(require,module,exports){
// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var util = require('../src/util')
var Global = util.Global

module.exports = {
	name: 'oldFF-globalStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var globalStorage = Global.globalStorage

function read(key) {
	return globalStorage[key]
}

function write(key, data) {
	globalStorage[key] = data
}

function each(fn) {
	for (var i = globalStorage.length - 1; i >= 0; i--) {
		var key = globalStorage.key(i)
		fn(globalStorage[key], key)
	}
}

function remove(key) {
	return globalStorage.removeItem(key)
}

function clearAll() {
	each(function(key, _) {
		delete globalStorage[key]
	})
}

},{"../src/util":7}],13:[function(require,module,exports){
// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var util = require('../src/util')
var Global = util.Global

module.exports = {
	name: 'oldIE-userDataStorage',
	write: write,
	read: read,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var storageName = 'storejs'
var doc = Global.document
var _withStorageEl = _makeIEStorageElFunction()
var disable = (Global.navigator ? Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x

function write(unfixedKey, data) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.setAttribute(fixedKey, data)
		storageEl.save(storageName)
	})
}

function read(unfixedKey) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	var res = null
	_withStorageEl(function(storageEl) {
		res = storageEl.getAttribute(fixedKey)
	})
	return res
}

function each(callback) {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		for (var i=attributes.length-1; i>=0; i--) {
			var attr = attributes[i]
			callback(storageEl.getAttribute(attr.name), attr.name)
		}
	})
}

function remove(unfixedKey) {
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.removeAttribute(fixedKey)
		storageEl.save(storageName)
	})
}

function clearAll() {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		storageEl.load(storageName)
		for (var i=attributes.length-1; i>=0; i--) {
			storageEl.removeAttribute(attributes[i].name)
		}
		storageEl.save(storageName)
	})
}

// Helpers
//////////

// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
function fixKey(key) {
	return key.replace(/^\d/, '___$&').replace(forbiddenCharsRegex, '___')
}

function _makeIEStorageElFunction() {
	if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) {
		return null
	}
	var scriptTag = 'script',
		storageOwner,
		storageContainer,
		storageEl

	// Since #userData storage applies only to specific paths, we need to
	// somehow link our data to a specific path.  We choose /favicon.ico
	// as a pretty safe option, since all browsers already make a request to
	// this URL anyway and being a 404 will not hurt us here.  We wrap an
	// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
	// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
	// since the iframe access rules appear to allow direct access and
	// manipulation of the document element, even for a 404 page.  This
	// document can be used instead of the current document (which would
	// have been limited to the current path) to perform #userData storage.
	try {
		/* global ActiveXObject */
		storageContainer = new ActiveXObject('htmlfile')
		storageContainer.open()
		storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
		storageContainer.close()
		storageOwner = storageContainer.w.frames[0].document
		storageEl = storageOwner.createElement('div')
	} catch(e) {
		// somehow ActiveXObject instantiation failed (perhaps some special
		// security settings or otherwse), fall back to per-path storage
		storageEl = doc.createElement('div')
		storageOwner = doc.body
	}

	return function(storeFunction) {
		var args = [].slice.call(arguments, 0)
		args.unshift(storageEl)
		// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
		// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
		storageOwner.appendChild(storageEl)
		storageEl.addBehavior('#default#userData')
		storageEl.load(storageName)
		storeFunction.apply(this, args)
		storageOwner.removeChild(storageEl)
		return
	}
}

},{"../src/util":7}],14:[function(require,module,exports){
var util = require('../src/util')
var Global = util.Global

module.exports = {
	name: 'sessionStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll
}

function sessionStorage() {
	return Global.sessionStorage
}

function read(key) {
	return sessionStorage().getItem(key)
}

function write(key, data) {
	return sessionStorage().setItem(key, data)
}

function each(fn) {
	for (var i = sessionStorage().length - 1; i >= 0; i--) {
		var key = sessionStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return sessionStorage().removeItem(key)
}

function clearAll() {
	return sessionStorage().clear()
}

},{"../src/util":7}],15:[function(require,module,exports){
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApiForUrl = void 0;

var _store = _interopRequireDefault(require("store"));

var _browserCookies = _interopRequireDefault(require("browser-cookies"));

var _base = _interopRequireDefault(require("base-64"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var getApiForUrl = function getApiForUrl(initialApiBaseUrl) {
  var API_URL_PREFIX = '/rest/v2';
  var API_TOKEN_COOKIE_NAME = 'token';
  var MAX_UUIDS_FOR_ONE_GET = 50;
  var apiBaseUrl = initialApiBaseUrl;
  var timeout = 30; // timeout for server calls in seconds

  var getApiBaseUrlWithPrefix = function getApiBaseUrlWithPrefix() {
    return apiBaseUrl + API_URL_PREFIX;
  };

  var timeoutPromise = function timeoutPromise(timeoutInSeconds) {
    return new Promise(function (resolve, reject) {
      setTimeout(resolve, timeoutInSeconds * 1000, 'NETWORK_TIMEOUT');
    });
  };

  var executeApiCallWithAjax = function executeApiCallWithAjax(apiUrlSuffix, optionalPostData) {
    return executeApiCallWithAjaxAndUserDefinedTimeout(timeout, apiUrlSuffix, optionalPostData);
  };

  var executeApiCallWithAjaxAndUserDefinedTimeout = function executeApiCallWithAjaxAndUserDefinedTimeout(timeoutInSeconds, apiUrlSuffix, optionalPostData) {
    return Promise.race([executeApiCallWithAjaxWithoutTimeout(apiUrlSuffix, optionalPostData), timeoutPromise(timeoutInSeconds)]).then(function (response) {
      if (response != null && response == 'NETWORK_TIMEOUT') {
        throwApiError('NETWORK_TIMEOUT');
      }

      return response;
    });
  }; // optionalPostData must be form-urlencoded: name=value


  var executeApiCallWithAjaxWithoutTimeout = function executeApiCallWithAjaxWithoutTimeout(apiUrlSuffix, optionalPostData) {
    var apiUrl = getApiBaseUrlWithPrefix() + apiUrlSuffix;
    var fetchProperties = {
      method: 'POST',
      mode: 'cors',
      cache: 'default',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-ApiVersion': '2.0'
      }
    };
    var apiToken = api.getApiToken();

    if (apiToken != null) {
      fetchProperties.headers['X-Auth'] = 'RememberMeToken ' + _base["default"].encode(apiToken);
    }

    if (optionalPostData != null) {
      fetchProperties.body = optionalPostData;
    }

    return fetch(apiUrl, fetchProperties).then(function (response) {
      // our server api return 401 if the authorization information provided is invalid
      // if the auth is okay, but you are not allowed to access a certain resource,
      // you will just not get the result or an empty result
      if (response.status === 401) {
        throwApiError('INVALID_TOKEN', apiUrl);
      } else if (response.status === 444) {
        throwApiError('ACCESS_BLOCKED_FROM_COUNTRY', apiUrl);
      } else if (response.status === 403) {
        throwApiError('ACCESS_BLOCKED_FROM_IP', apiUrl);
      } else if (response.status > 400) {
        throwApiError('BAD_API_SERVER_RESPONSE', apiUrl);
      } else {
        return response.json().then(function (json) {
          var result = json.result;

          if (result === 'SUCCESS') {
            return json;
          } else if (result === 'ERROR') {
            var specificErrorMessage = errorMessageFromApiResponse(json);
            throwApiError(specificErrorMessage != null ? specificErrorMessage : 'UNKNOWN_ERROR_IN_API_CALL', errorDetailsFromApiResponse(json));
          } else {
            throwApiError('UNKNOWN_API_SERVER_REPONSE', apiUrl);
          }
        });
      }
    })["catch"](function (e) {
      if (e.message != null && e.message.indexOf('Failed to fetch') > -1) {
        throwApiError('NETWORK_ERROR', e);
      } else if (e.message != null && e.message.indexOf('Failed to authorize authentication') > -1) {
        throwApiError('NO_PERMISSION', e);
      }

      throw e;
    });
  }; // errorHandlers are functions that get executed on each error that occurs, they get passed the error object


  var errorHandlers = new Array(); // central function for errors, calls error handlers and eventually throws the api error

  var throwApiError = function throwApiError(message, details) {
    var apiError = new ApiError(message, details);

    try {
      errorHandlers.forEach(function (handler) {
        return handler(apiError);
      });
    } catch (e) {
      throw new ApiError('ERROR_HANDLING_ERROR', {
        apiError: apiError,
        handlingError: e
      });
    }

    throw apiError;
  }; // gets the api error message from an apiresponse, returns null if there is none


  var errorMessageFromApiResponse = function errorMessageFromApiResponse(apiResponse) {
    return apiResponse == null || apiResponse.result != 'ERROR' || apiResponse.meta == null || apiResponse.meta.error == null ? null : apiResponse.meta.error.message;
  }; // gets the api error message from an apiresponse, returns an empty object if there are none


  var errorDetailsFromApiResponse = function errorDetailsFromApiResponse(apiResponse) {
    return apiResponse == null || apiResponse.result != 'ERROR' || apiResponse.meta == null || apiResponse.meta.error == null || apiResponse.meta.error.details == null ? {} : apiResponse.meta.error.details;
  };

  var ApiError = /*#__PURE__*/function (_Error) {
    _inherits(ApiError, _Error);

    var _super = _createSuper(ApiError);

    function ApiError(message, details) {
      var _this;

      _classCallCheck(this, ApiError);

      _this = _super.call(this, message);
      _this.message = message; // redundant, but required for IE comptability

      _this.details = details;
      _this.name = _this.constructor.name;

      if (typeof Error.captureStackTrace === 'function') {
        Error.captureStackTrace(_assertThisInitialized(_this), _this.constructor);
      } else {
        _this.stack = new Error(message).stack;
      }

      return _this;
    }

    return ApiError;
  }( /*#__PURE__*/_wrapNativeSuper(Error));

  var api = {};

  api.setTimeout = function (timeoutInSeconds) {
    timeout = timeoutInSeconds;
  };

  api.getTimeout = function () {
    return timeout;
  };

  api.setApiBaseUrl = function (newApiBaseUrl) {
    apiBaseUrl = newApiBaseUrl;
  };

  api.getApiBaseUrl = function () {
    return apiBaseUrl;
  };

  api.addErrorHandler = function (handler) {
    errorHandlers.push(handler);
  }; // ********************** AUTHENTICATION AND STORING TOKENS **********************


  api.setApiAuth = function (username, password) {
    return executeApiCallWithAjax('/token?username=' + encodeURIComponent(username), 'password=' + encodeURIComponent(password)).then(function (response) {
      var token = response.payload;
      api.setApiToken(token);
      return token;
    });
  };

  api.getApiToken = function () {
    // we should always save in the local storage (more stable). To support legacy cookies stored on the clients right now, we read from the cookie store as a fallback
    var tokenFromLocalStorage = getTokenFromLocalStorage();

    if (tokenFromLocalStorage != null) {
      return tokenFromLocalStorage;
    } else {
      var tokenFromCookie = getTokenFromCookie();

      if (tokenFromCookie != null) {
        api.setApiToken(tokenFromCookie);
      }

      return tokenFromCookie;
    }
  };

  api.setApiToken = function (apiToken) {
    // we should always save in the local storage (more stable). We delete any old cookies that might still hang around on the client
    saveTokenInLocalStorage(apiToken);
    saveTokenAsCookie(null);
  }; // if the user is authenticated, returns the username (useruuid for typical users, can also be bvAdmin or the like)


  api.getApiAuthUsername = function () {
    var token = api.getApiToken();
    return token == null ? null : token.split(':')[0];
  }; // if the user is authenticated, returns the point in time in which the token expires


  api.getApiAuthExpiration = function () {
    var token = api.getApiToken();
    return token == null ? null : new Date(Number(token.split(':')[1]));
  }; // if a user is authenticated, checks if the token is expired


  api.isApiAuthExpired = function () {
    var dateOfExpiration = api.getApiAuthExpiration();
    return dateOfExpiration == null ? false : new Date() > dateOfExpiration;
  };

  var TOKEN_LOCAL_STORAGE_SECTION = 'api-authentication';

  var saveTokenInLocalStorage = function saveTokenInLocalStorage(token) {
    _store["default"].set(TOKEN_LOCAL_STORAGE_SECTION, {
      token: token
    });
  };

  var getTokenFromLocalStorage = function getTokenFromLocalStorage() {
    var storageSection = _store["default"].get(TOKEN_LOCAL_STORAGE_SECTION);

    return storageSection != null ? storageSection.token : null;
  }; // ********************** OLD COOKIE PERSISTENCY FOR TOKEN *******************
  // OBSOLETE: DELETE AFTER A GRACE PERIOD, WHEN WE HAVE MOST PROBABLY MIGRATED ALL COOKIES FROM OUR CLIENTS


  var saveTokenAsCookie = function saveTokenAsCookie(token) {
    var expiryDate = token != null ? new Date(2100, 1, 1, 1, 1, 1, 1) : new Date(1970, 1, 1, 1, 1, 1, 1);

    var base64encodedToken = _base["default"].encode(token);

    _browserCookies["default"].set(API_TOKEN_COOKIE_NAME, base64encodedToken, {
      expires: expiryDate
    });
  }; // OBSOLETE: DELETE AFTER A GRACE PERIOD, WHEN WE HAVE MOST PROBABLY MIGRATED ALL COOKIES FROM OUR CLIENTS
  // tries to get a token from the cookie store, returns null if there is no token cookie


  var getTokenFromCookie = function getTokenFromCookie() {
    var base64encodedToken = _browserCookies["default"].get(API_TOKEN_COOKIE_NAME);

    var token = base64encodedToken == null ? null : _base["default"].decode(base64encodedToken);
    return token;
  }; // ********************** PUBLIC SERVICE API FUNCTIONS *******************
  // all pure user sell related functions


  api.userSells = {};
  api.userSells.products = {}; // search for products by keywords

  api.userSells.products.search = function (keywords) {
    keywords = encodeURIComponent(keywords);
    return executeApiCallWithAjax('/products/sell?q=' + keywords);
  };

  api.userSells.products.searchFiltered = function (keywords, filterProductCategoryUuids) {
    keywords = encodeURIComponent(keywords);
    filterProductCategoryUuids = encodeURIComponent(filterProductCategoryUuids);
    return executeApiCallWithAjax('/products/sell?q=' + keywords + '&productCategoryFilterUuids=' + filterProductCategoryUuids);
  };

  api.userSells.products.getByExternalId = function (externalId) {
    return executeApiCallWithAjax('/products/' + externalId);
  };

  api.userSells.products.getByExternalIdAndConfig = function (externalId, configuration) {
    var configurationEncoded = encodeURIComponent(configuration);
    var configurationPostParam = configuration ? 'configuration=' + configurationEncoded : '';
    return executeApiCallWithAjax('/products/' + externalId, configurationPostParam);
  };

  api.userSells.products.getByExternalIdWithConditionLevel = function (externalId, conditionLevelUuid) {
    conditionLevelUuid = encodeURIComponent(conditionLevelUuid);
    return executeApiCallWithAjax('/products/' + externalId + '?conditionLevelUuid=' + conditionLevelUuid);
  };

  api.userSells.products.getByExternalIdWithConditionLevelAndConfig = function (externalId, conditionLevelUuid, configuration) {
    conditionLevelUuid = encodeURIComponent(conditionLevelUuid);
    var conditionLevelUuidPostParam = conditionLevelUuid ? 'conditionLevelUuid=' + conditionLevelUuid : '';
    var configurationEncoded = encodeURIComponent(configuration);
    var configurationPostParameter = configuration ? '&configuration=' + configurationEncoded : '';
    var postParams = conditionLevelUuidPostParam + configurationPostParameter;
    return executeApiCallWithAjax('/products/' + externalId, postParams);
  };

  api.userSells.products.getConfigurations = function (externalIdOrUuid) {
    return executeApiCallWithAjax('/products/configurations/' + externalIdOrUuid);
  };

  api.userSells.products.getConfigurationOptions = function (externalIdOrUuid) {
    return executeApiCallWithAjax('/products/configuration/options/' + externalIdOrUuid);
  };

  api.userSells.products.findByParentModel = function (productCategoryUuid, parentModelId) {
    return executeApiCallWithAjax("/products/buy/".concat(productCategoryUuid, "/").concat(parentModelId));
  };

  api.userSells.brands = {};

  api.userSells.brands.getBrandsForCategory = function (productCategoryUuid) {
    return executeApiCallWithAjax("/brands/buy/".concat(productCategoryUuid));
  };

  api.userSells.productModels = {};

  api.userSells.productModels.getModelsForCategoryAndBrand = function (productCategoryUuid, brandId, parentModelId) {
    var parentModelIdParam = parentModelId ? "?parentModelId=".concat(parentModelId) : '';
    return executeApiCallWithAjax("/productModels/buy/".concat(productCategoryUuid, "/").concat(brandId).concat(parentModelIdParam));
  };

  api.userSells.partners = {};

  api.userSells.partners.getAllEnabled = function () {
    return executeApiCallWithAjax('/buyPartners');
  };

  api.userSells.productCategories = {};

  api.userSells.productCategories.get = function () {
    return executeApiCallWithAjax('/productCategories?userSells=true');
  };

  api.userSells.partners.ratings = function (partnerUuid) {
    partnerUuid = encodeURIComponent(partnerUuid);
    return executeApiCallWithAjax('/partnerBuyTransactions/ratings/' + partnerUuid);
  };

  api.userSells.partners.rate = function (partnerUuid, authorUserUuid, score, comment) {
    partnerUuid = encodeURIComponent(partnerUuid);
    authorUserUuid = encodeURIComponent(authorUserUuid);
    score = encodeURIComponent(score);
    comment = comment == null ? null : encodeURIComponent(comment);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/ratings/' + authorUserUuid + '/set?score=' + score + (comment == null ? '' : '&comment=' + comment));
  };

  api.userSells.partners.deleteRating = function (partnerUuid, authorUserUuid) {
    partnerUuid = encodeURIComponent(partnerUuid);
    authorUserUuid = encodeURIComponent(authorUserUuid);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/ratings/' + authorUserUuid + '/delete');
  };

  api.userSells.partners.setRatingPartnerReply = function (partnerUuid, authorUserUuid, reply) {
    partnerUuid = encodeURIComponent(partnerUuid);
    authorUserUuid = encodeURIComponent(authorUserUuid);
    reply = encodeURIComponent(reply);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/ratings/' + authorUserUuid + '/setPartnerReply?reply=' + reply);
  };

  api.userSells.partners.deleteRatingPartnerReply = function (partnerUuid, authorUserUuid) {
    partnerUuid = encodeURIComponent(partnerUuid);
    authorUserUuid = encodeURIComponent(authorUserUuid);
    reply = encodeURIComponent(reply);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/ratings/' + authorUserUuid + '/deletePartnerReply');
  };

  api.userSells.partners.conditionLevels = {};

  api.userSells.partners.conditionLevels.create = function (partnerUuid, productCategoryUuid, theName, conditionPercentage, description) {
    partnerUuid = encodeURIComponent(partnerUuid);
    productCategoryUuid = encodeURIComponent(productCategoryUuid);
    theName = encodeURIComponent(theName);
    conditionPercentage = encodeURIComponent(conditionPercentage);
    description = encodeURIComponent(description);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/conditionLevels/create?productCategoryUuid=' + productCategoryUuid + '&name=' + theName + '&conditionPercentage=' + conditionPercentage + '&description=' + description);
  };

  api.userSells.partners.conditionLevels.setName = function (partnerUuid, productConditionLevelUuid, conditionLevelName) {
    partnerUuid = encodeURIComponent(partnerUuid);
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    conditionLevelName = encodeURIComponent(conditionLevelName);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/conditionLevels/' + productConditionLevelUuid + '/setName?name=' + conditionLevelName);
  };

  api.userSells.partners.conditionLevels.setDescription = function (partnerUuid, productConditionLevelUuid, conditionLevelDescription) {
    partnerUuid = encodeURIComponent(partnerUuid);
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    conditionLevelDescription = encodeURIComponent(conditionLevelDescription);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/conditionLevels/' + productConditionLevelUuid + '/setDescription?description=' + conditionLevelDescription);
  };

  api.userSells.partners.conditionLevels.setPercentage = function (partnerUuid, productConditionLevelUuid, conditionLevelPercentage) {
    partnerUuid = encodeURIComponent(partnerUuid);
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    conditionLevelPercentage = encodeURIComponent(conditionLevelPercentage);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/conditionLevels/' + productConditionLevelUuid + '/setPercentage?percentage=' + conditionLevelPercentage);
  };

  api.userSells.partners.conditionLevels["delete"] = function (partnerUuid, productConditionLevelUuid) {
    partnerUuid = encodeURIComponent(partnerUuid);
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    return executeApiCallWithAjax('/partners/' + partnerUuid + '/conditionLevels/' + productConditionLevelUuid + '/delete');
  }; // ******************************** PRODUCT CONDITION LEVELS ********************************************


  api.userSells.productConditionLevels = {};

  api.userSells.productConditionLevels.getAll = function (productCategoryUuid) {
    if (productCategoryUuid != null) {
      productCategoryUuid = encodeURIComponent(productCategoryUuid);
    }

    return executeApiCallWithAjax('/productConditionLevels' + (productCategoryUuid == null ? '' : '?productCategoryUuid=' + productCategoryUuid));
  };

  api.userSells.productConditionLevels.create = function (productCategoryUuid, theName, description, conditionPercentage) {
    productCategoryUuid = encodeURIComponent(productCategoryUuid);
    theName = encodeURIComponent(theName);
    conditionPercentage = encodeURIComponent(conditionPercentage);
    description = encodeURIComponent(description);
    return executeApiCallWithAjax('/productConditionLevels/create?productCategoryUuid=' + productCategoryUuid + '&name=' + theName + '&conditionPercentage=' + conditionPercentage + '&description=' + description);
  };

  api.userSells.productConditionLevels.setDefault = function (productConditionLevelUuid) {
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    return executeApiCallWithAjax('/productConditionLevels/' + productConditionLevelUuid + '/setDefault');
  };

  api.userSells.productConditionLevels.setName = function (productConditionLevelUuid, conditionLevelName) {
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    conditionLevelName = encodeURIComponent(conditionLevelName);
    return executeApiCallWithAjax('/productConditionLevels/' + productConditionLevelUuid + '/setName?name=' + conditionLevelName);
  };

  api.userSells.productConditionLevels.setDescription = function (productConditionLevelUuid, conditionLevelDescription) {
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    conditionLevelDescription = encodeURIComponent(conditionLevelDescription);
    return executeApiCallWithAjax('/productConditionLevels/' + productConditionLevelUuid + '/setDescription?description=' + conditionLevelDescription);
  };

  api.userSells.productConditionLevels.setPercentage = function (productConditionLevelUuid, conditionLevelPercentage) {
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    conditionLevelPercentage = encodeURIComponent(conditionLevelPercentage);
    return executeApiCallWithAjax('/productConditionLevels/' + productConditionLevelUuid + '/setPercentage?percentage=' + conditionLevelPercentage);
  };

  api.userSells.productConditionLevels["delete"] = function (productConditionLevelUuid) {
    productConditionLevelUuid = encodeURIComponent(productConditionLevelUuid);
    return executeApiCallWithAjax('/productConditionLevels/' + productConditionLevelUuid + '/delete');
  }; // ******************************** TRANSACTIONS ********************************************


  api.userSells.transactions = {};

  api.userSells.transactions.getTransactions = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid + '/userSellTransactions');
  };

  api.userSells.transactions.createTransaction = function (userUuid, partnerUuid, startedDate) {
    partnerUuid = encodeURIComponent(partnerUuid);
    startedDate = encodeURIComponent(startedDate.getTime());
    return executeApiCallWithAjax('/users/' + userUuid + '/userSellTransactions/create?partnerBuyUuid=' + partnerUuid + '&startedTimestamp=' + startedDate);
  };

  api.userSells.transactions.getTransaction = function (transactionUuid) {
    transactionUuid = encodeURIComponent(transactionUuid);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid);
  };

  api.userSells.transactions.setEnded = function (transactionUuid, endedDate) {
    transactionUuid = encodeURIComponent(transactionUuid);
    endedDate = encodeURIComponent(endedDate.getTime());
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/setEnded?endedTimestamp=' + endedDate);
  };

  api.userSells.transactions.setNextStep = function (transactionUuid, nextStep) {
    transactionUuid = encodeURIComponent(transactionUuid);
    nextStep = encodeURIComponent(nextStep);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/setNextStep?nextStep=' + nextStep);
  };

  api.userSells.transactions.getNextSteps = function (callback) {
    return executeApiCallWithAjax('/partnerBuyTransactions/nextSteps');
  };

  api.userSells.transactions.rate = function (transactionUuid, score, comment) {
    transactionUuid = encodeURIComponent(transactionUuid);
    score = encodeURIComponent(score);
    comment = comment == null ? null : encodeURIComponent(comment);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/setRating?score=' + score + (comment == null ? '' : '&comment=' + comment));
  };

  api.userSells.transactions.deleteRating = function (transactionUuid) {
    transactionUuid = encodeURIComponent(transactionUuid);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/deleteRating');
  };

  api.userSells.transactions.setRatingPartnerReply = function (transactionUuid, partnerReply) {
    transactionUuid = encodeURIComponent(transactionUuid);
    partnerReply = encodeURIComponent(partnerReply);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/setRatingPartnerReply?reply=' + partnerReply);
  };

  api.userSells.transactions.deleteRatingPartnerReply = function (transactionUuid) {
    transactionUuid = encodeURIComponent(transactionUuid);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/deleteRatingPartnerReply');
  };

  api.userSells.transactions.deleteTransaction = function (transactionUuid) {
    transactionUuid = encodeURIComponent(transactionUuid);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/delete');
  };

  api.userSells.transactions.addProduct = function (transactionUuid, productUuid, quantity, price) {
    transactionUuid = encodeURIComponent(transactionUuid);
    productUuid = encodeURIComponent(productUuid);
    quantity = encodeURIComponent(quantity);
    price = encodeURIComponent(price);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/' + productUuid + '/add?quantity=' + quantity + '&price=' + price);
  };

  api.userSells.transactions.addProducts = function (transactionUuid, productUuids, quantities, prices) {
    var productUuidsPostParam = productUuids.reduce(function (acc, productUuid) {
      return acc + (acc == '' ? 'productUuids=' : ',') + productUuid;
    }, '');
    var quantitiesPostParam = quantities.reduce(function (acc, quantity) {
      return acc + (acc == '' ? 'quantities=' : ',') + quantity;
    }, '');
    var pricesPostParam = prices.reduce(function (acc, price) {
      return acc + (acc == '' ? 'prices=' : ',') + price;
    }, '');
    var postParam = productUuidsPostParam + '&' + quantitiesPostParam + '&' + pricesPostParam;
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/addProducts', postParam);
  };

  api.userSells.transactions.setUser = function (transactionUuids, userUuid) {
    if (transactionUuids == null || transactionUuids.length == 0) {
      return Promise.resolve();
    } else {
      var transactionUuidsPostParam = transactionUuids.reduce(function (acc, uuid) {
        return acc + (acc == '' ? 'transactionUuids=' : ',') + uuid;
      }, '');
      userUuid = encodeURIComponent(userUuid);
      return executeApiCallWithAjax('/partnerBuyTransactions/setUser?userUuid=' + userUuid, transactionUuidsPostParam);
    }
  };

  api.userSells.transactions.removeProducts = function (transactionUuid, productUuids, quantities) {
    var productUuidsPostParam = productUuids.reduce(function (acc, productUuid) {
      return acc + (acc == '' ? 'productUuids=' : ',') + productUuid;
    }, '');
    var quantitiesPostParam = quantities.reduce(function (acc, quantity) {
      return acc + (acc == '' ? 'quantities=' : ',') + quantity;
    }, '');
    var postParam = productUuidsPostParam + '&' + pricesPostParam;
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/removeProducts', postParam);
  };

  api.userSells.transactions.removeProduct = function (transactionUuid, productUuid, quantity) {
    transactionUuid = encodeURIComponent(transactionUuid);
    productUuid = encodeURIComponent(productUuid);
    quantity = encodeURIComponent(quantity);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/' + productUuid + '/remove?quantity=' + quantity);
  };

  api.userSells.transactions.setProductPrice = function (transactionUuid, productUuid, price) {
    transactionUuid = encodeURIComponent(transactionUuid);
    productUuid = encodeURIComponent(productUuid);
    price = encodeURIComponent(price);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/' + productUuid + '/setPrice?price=' + price);
  };

  api.userSells.transactions.setProductProcessed = function (transactionUuid, productUuid, processed) {
    transactionUuid = encodeURIComponent(transactionUuid);
    productUuid = encodeURIComponent(productUuid);
    processed = encodeURIComponent(processed);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/' + productUuid + '/setProcessed?processed=' + processed);
  };

  api.userSells.transactions.setProductPartnerProductId = function (transactionUuid, productUuid, partnerProductId) {
    transactionUuid = encodeURIComponent(transactionUuid);
    productUuid = encodeURIComponent(productUuid);
    partnerProductId = encodeURIComponent(partnerProductId);
    return executeApiCallWithAjax('/partnerBuyTransactions/' + transactionUuid + '/' + productUuid + '/setPartnerProductId?partnerProductId=' + partnerProductId);
  };

  api.userSells.getUserBag = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid + '/buyBag');
  };

  api.userSells.addProductToUserBag = function (userUuid, productUuid) {
    productUuid = encodeURIComponent(productUuid);
    return executeApiCallWithAjax('/users/' + userUuid + '/buyBag/addProduct?productUuid=' + productUuid);
  }; // returns a promise with the product bag items that actually were added


  api.userSells.addProductsToUserBag = function (userUuid, productUuids) {
    if (productUuids == null || productUuids.length == 0) {
      return Promise.resolve([]);
    } else {
      var productUuidsPostParam = productUuids.reduce(function (acc, productUuid) {
        return acc + (acc == '' ? 'productUuids=' : ',') + productUuid;
      }, '');
      return executeApiCallWithAjax('/users/' + userUuid + '/buyBag/addProducts', productUuidsPostParam);
    }
  };

  api.userSells.removeProductsFromUserBag = function (userUuid, productUuids) {
    if (productUuids == null || productUuids.length == 0) {
      return;
    } else {
      var productUuidsPostParam = productUuids.reduce(function (acc, productUuid) {
        return acc + (acc == '' ? 'productUuids=' : ',') + productUuid;
      }, '');
      return executeApiCallWithAjax('/users/' + userUuid + '/buyBag/removeProducts', productUuidsPostParam);
    }
  };

  api.userSells.offers = {};

  api.userSells.offers.getRecentBestOffers = function (maxNumberOfItems, filterProductCategoryUuids, callback) {
    if (filterProductCategoryUuids != null) {
      filterProductCategoryUuids = encodeURIComponent(filterProductCategoryUuids);
    }

    var maxNumberOfItemsParameter = maxNumberOfItems == null ? '' : '?maxNumberOfItems=' + maxNumberOfItems;
    var parameterSuffix = '?';

    if (maxNumberOfItemsParameter !== '') {
      parameterSuffix = '&';
    }

    var filterProductCategoryUuidsParameter = filterProductCategoryUuids == null ? '' : parameterSuffix + 'filterProductCategoryUuids=' + filterProductCategoryUuids;
    return executeApiCallWithAjax('/recentBestOffers/buyOffers' + maxNumberOfItemsParameter + filterProductCategoryUuidsParameter, callback);
  };

  api.userSells.offers.getOffersForProduct = function (productId, partnerUuids, maxAgeOfOfferInMinutes) {
    if (partnerUuids != null) {
      partnerUuids = encodeURIComponent(partnerUuids);
    }

    if (maxAgeOfOfferInMinutes == null) {
      maxAgeOfOfferInMinutes = -1; // use the cache if no age is provided
    }

    maxAgeOfOfferInMinutes = encodeURIComponent(maxAgeOfOfferInMinutes);
    return executeApiCallWithAjax('/products/' + productId + '/buyOffers?maxAgeOfOfferInMinutes=' + maxAgeOfOfferInMinutes + (partnerUuids == null ? '' : '&partnerUuids=' + partnerUuids));
  };

  api.userSells.offers.getOffersForUserBag = function (userUuid, buyPartnerIdsToConsider, maxNumberOfPartnersToConsider, considerDealLimitations) {
    if (typeof maxNumberOfPartnersToConsider == 'undefined') {
      maxNumberOfPartnersToConsider = -1; // unlimited
    }

    if (typeof considerDealLimitations == 'undefined') {
      considerDealLimitations = false;
    }

    buyPartnerIdsToConsider = encodeURIComponent(buyPartnerIdsToConsider);
    maxNumberOfPartnersToConsider = encodeURIComponent(maxNumberOfPartnersToConsider);
    considerDealLimitations = encodeURIComponent(considerDealLimitations);
    return executeApiCallWithAjaxAndUserDefinedTimeout(120, '/users/' + userUuid + '/buyBag/bestOffers?buyPartnerIdsToConsider=' + buyPartnerIdsToConsider + '&maxNumberOfPartnersToConsider=' + maxNumberOfPartnersToConsider + '&considerDealLimitations=' + considerDealLimitations);
  };

  api.userSells.partners.getPartnersForUser = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid + '/partners/buy');
  };

  api.userSells.partners.getPreferredPartners = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid + '/preferredPartners/buy');
  };

  api.userSells.partners.addPreferredPartners = function (userUuid, partnerUuids) {
    partnerUuids = encodeURIComponent(partnerUuids);
    return executeApiCallWithAjax('/users/' + userUuid + '/preferredPartners/buy/add?partnerBuyUuids=' + partnerUuids);
  };

  api.userSells.partners.deletePreferredPartners = function (userUuid, partnerUuids) {
    partnerUuids = encodeURIComponent(partnerUuids);
    return executeApiCallWithAjax('/users/' + userUuid + '/preferredPartners/buy/remove?partnerUuids=' + partnerUuids);
  }; // all pure user buy related functions


  api.userBuys = {};
  api.userBuys.products = {}; // search for products by keywords

  api.userBuys.products.search = function (keywords) {
    keywords = encodeURIComponent(keywords);
    return executeApiCallWithAjax('/products/buy?q=' + keywords);
  };

  api.userBuys.products.searchFiltered = function (keywords, filterProductCategoryUuids) {
    keywords = encodeURIComponent(keywords);
    filterProductCategoryUuids = encodeURIComponent(filterProductCategoryUuids);
    return executeApiCallWithAjax('/products/buy?q=' + keywords + '&productCategoryFilterUuids=' + filterProductCategoryUuids);
  };

  api.userBuys.products.getByExternalId = function (externalId) {
    return executeApiCallWithAjax('/products/' + externalId);
  };

  api.userBuys.products.getByExternalIdWithConditionLevel = function (externalId, conditionLevelUuid) {
    conditionLevelUuid = encodeURIComponent(conditionLevelUuid);
    return executeApiCallWithAjax('/products/' + externalId + '?conditionLevelUuid=' + conditionLevelUuid);
  };

  api.userBuys.products.getConfigurations = function (externalIdOrUuid) {
    return executeApiCallWithAjax('/products/configurations/' + externalIdOrUuid);
  };

  api.userBuys.products.getByExternalIdAndConfig = function (externalId, configuration) {
    var configurationEncoded = encodeURIComponent(configuration);
    var configurationPostParam = configuration ? 'configuration=' + configurationEncoded : '';
    return executeApiCallWithAjax('/products/' + externalId, configurationPostParam);
  };

  api.userBuys.products.getConfigurationOptions = function (externalIdOrUuid) {
    return executeApiCallWithAjax('/products/configuration/options/' + externalIdOrUuid);
  };

  api.userBuys.productCategories = {};

  api.userBuys.productCategories.get = function (callback) {
    return executeApiCallWithAjax('/productCategories?userSells=false');
  };

  api.userBuys.offers = {};

  api.userBuys.offers.getRecentBestOffers = function (maxNumberOfItems, filterProductCategoryUuids, callback) {
    if (filterProductCategoryUuids != null) {
      filterProductCategoryUuids = encodeURIComponent(filterProductCategoryUuids);
    }

    var maxNumberOfItemsParameter = maxNumberOfItems == null ? '' : '?maxNumberOfItems=' + maxNumberOfItems;
    var parameterSuffix = '?';

    if (maxNumberOfItemsParameter !== '') {
      parameterSuffix = '&';
    }

    var filterProductCategoryUuidsParameter = filterProductCategoryUuids == null ? '' : parameterSuffix + 'filterProductCategoryUuids=' + filterProductCategoryUuids;
    return executeApiCallWithAjax('/recentBestOffers/sellOffers' + maxNumberOfItemsParameter + filterProductCategoryUuidsParameter, callback);
  };

  api.userBuys.offers.getOffersForProduct = function (productId, partnerUuids, maxAgeOfOfferInMinutes) {
    if (partnerUuids != null) {
      partnerUuids = encodeURIComponent(partnerUuids);
    }

    if (maxAgeOfOfferInMinutes == null) {
      maxAgeOfOfferInMinutes = -1; // use the cache if no age is provided
    }

    maxAgeOfOfferInMinutes = encodeURIComponent(maxAgeOfOfferInMinutes);
    return executeApiCallWithAjax('/products/' + productId + '/sellOffers?maxAgeOfOfferInMinutes=' + maxAgeOfOfferInMinutes + (partnerUuids == null ? '' : '&partnerUuids=' + partnerUuids));
  };

  api.userBuys.offers.getOffersForUserBag = function (userUuid, sellPartnerIdsToConsider, maxNumberOfPartnersToConsider, considerDealLimitations) {
    if (typeof maxNumberOfPartnersToConsider == 'undefined') {
      maxNumberOfPartnersToConsider = -1; // unlimited
    } // considerDealLimitations is ignored, not supported by the endpoint


    sellPartnerIdsToConsider = encodeURIComponent(sellPartnerIdsToConsider);
    maxNumberOfPartnersToConsider = encodeURIComponent(maxNumberOfPartnersToConsider);
    return executeApiCallWithAjaxAndUserDefinedTimeout(120, '/users/' + userUuid + '/sellBag/bestOffers?sellPartnerIdsToConsider=' + sellPartnerIdsToConsider + '&maxNumberOfPartnersToConsider=' + maxNumberOfPartnersToConsider);
  };

  api.userBuys.getUserBag = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid + '/sellBag');
  };

  api.userBuys.addProductToUserBag = function (userUuid, productUuid) {
    productUuid = encodeURIComponent(productUuid);
    return executeApiCallWithAjax('/users/' + userUuid + '/sellBag/addProduct?productUuid=' + productUuid);
  };

  api.userBuys.addProductsToUserBag = function (userUuid, productUuids) {
    if (productUuids == null || productUuids.length == 0) {
      return null;
    }

    var productUuidsPostParam = productUuids.reduce(function (acc, productUuid) {
      return acc + (acc == '' ? 'productUuids=' : ',') + productUuid;
    }, '');
    return executeApiCallWithAjax('/users/' + userUuid + '/sellBag/addProducts', productUuidsPostParam);
  };

  api.userBuys.removeProductsFromUserBag = function (userUuid, productUuids) {
    if (productUuids == null || productUuids.length == 0) {
      return;
    } else {
      var productUuidsPostParam = productUuids.reduce(function (acc, productUuid) {
        return acc + (acc == '' ? 'productUuids=' : ',') + productUuid;
      }, '');
      return executeApiCallWithAjax('/users/' + userUuid + '/sellBag/removeProducts', productUuidsPostParam);
    }
  };

  api.userBuys.partners = {};

  api.userBuys.partners.getAllEnabled = function (callback) {
    return executeApiCallWithAjax('/sellPartners');
  };

  api.userBuys.partners.getPartnersForUser = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid + '/partners/sell');
  };

  api.userBuys.partners.getPreferredPartners = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid + '/preferredPartners/sell');
  };

  api.userBuys.partners.addPreferredPartners = function (userUuid, partnerUuids) {
    partnerUuids = encodeURIComponent(partnerUuids);
    return executeApiCallWithAjax('/users/' + userUuid + '/preferredPartners/sell/add?partnerUuids=' + partnerUuids);
  };

  api.userBuys.partners.deletePreferredPartners = function (userUuid, partnerUuids) {
    partnerUuids = encodeURIComponent(partnerUuids);
    return executeApiCallWithAjax('/users/' + userUuid + '/preferredPartners/sell/remove?partnerUuids=' + partnerUuids);
  }; // all users related functions


  api.users = {};

  api.users.getUserByEmail = function (email) {
    return executeApiCallWithAjax('/users/email?email=' + encodeURIComponent(email));
  };

  api.users.getUserByUuid = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid);
  };

  api.users.signupUser = function (email, nickname) {
    return executeApiCallWithAjax('/users/signup?email=' + encodeURIComponent(email) + '&nickName=' + encodeURIComponent(nickname));
  };

  api.users.createAnonymousUser = function (password) {
    return executeApiCallWithAjax('/users/createAnonymousUser', 'password=' + encodeURIComponent(password));
  };

  api.users.requestPasswordResetTokenViaEmail = function (userEmail) {
    return executeApiCallWithAjax('/users/requestPasswordResetToken?email=' + encodeURIComponent(userEmail));
  };

  api.users.setPasswordWithToken = function (passwordResetToken, newPassword) {
    return executeApiCallWithAjax('/users/setPasswordWithToken?passwordResetToken=' + encodeURIComponent(passwordResetToken), 'password=' + encodeURIComponent(newPassword));
  }; // special: we pass a user object here, has to be a POJO!


  api.users.setUser = function (user) {
    var urlParameters = '?' + 'firstName=' + encodeURIComponent(user.firstName) + '&' + 'lastName=' + encodeURIComponent(user.lastName) + '&' + 'nickname=' + encodeURIComponent(user.nickname) + '&' + 'title=' + encodeURIComponent(user.title) + '&' + 'address=' + encodeURIComponent(user.address) + '&' + 'phone=' + encodeURIComponent(user.phone) + '&' + 'male=' + encodeURIComponent(user.male) + '&' + 'isAllowTransactionalMails=' + encodeURIComponent(user.allowTransactionalMails);
    return executeApiCallWithAjax('/users/' + user.uuid + '/set' + urlParameters);
  };

  api.users.setPassword = function (userUuid, password) {
    return executeApiCallWithAjax('/users/' + userUuid + '/setPassword', 'password=' + encodeURIComponent(password));
  };

  api.users.setNickname = function (userUuid, nickname) {
    return executeApiCallWithAjax('/users/' + userUuid + '/setNickname?nickname=' + encodeURIComponent(nickname));
  };

  api.users.setEmail = function (userUuid, email) {
    return executeApiCallWithAjax('/users/' + userUuid + '/setEmail?email=' + encodeURIComponent(email));
  };

  api.users.deleteUser = function (userUuid) {
    return executeApiCallWithAjax('/users/' + userUuid + '/delete');
  }; // all messaging related functions


  api.messages = {};

  api.messages.sendPassword = function (userUuid, newPassword) {
    userUuid = encodeURIComponent(userUuid);
    newPassword = encodeURIComponent(newPassword);
    return executeApiCallWithAjax('/messages/password?userUuid=' + userUuid + '&newPassword=' + encodeURIComponent(newPassword));
  };

  api.messages.sendTransactionalMailUserBuyBag = function (userUuid, itemsInBag) {
    userUuid = encodeURIComponent(userUuid);
    itemsInBag = encodeURIComponent(itemsInBag);
    return executeApiCallWithAjax('/messages/transactionalMails/userBuyBag?userUuid=' + userUuid + '&numberOfItemsInBag=' + itemsInBag);
  };

  api.messages.sendTransactionalMailLongTimeNoInteraction = function (userUuid) {
    userUuid = encodeURIComponent(userUuid);
    return executeApiCallWithAjax('/messages/transactionalMails/longTimeNoInteraction?userUuid=' + userUuid);
  };

  api.messages.sendTransactionalMailCompletedUserSellTransaction = function (userUuid, buyPartnerUuid) {
    userUuid = encodeURIComponent(userUuid);
    buyPartnerUuid = encodeURIComponent(buyPartnerUuid);
    return executeApiCallWithAjax('/messages/transactionalMails/completedUserSellTransaction?userUuid=' + userUuid + '&buyPartnerUuid=' + buyPartnerUuid);
  };

  return api;
};

exports.getApiForUrl = getApiForUrl;

},{"base-64":1,"browser-cookies":2,"store":3}]},{},[15])(15)
});
